module.exports = __webpack_public_path__ + "static/ctaBackground-e885bb990de7aecaa2d4750cef3c0a55.svg";